import { OnInit, Component, ViewChild } from '@angular/core';
import { Http, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';
import { Angulartics2 } from 'angulartics2';
import * as moment from 'moment';

import { environment } from '../../environments/environment';

import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';

declare var $:any;

@Component({
  selector: 'app-sessions',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.scss']
})
export class SessionsComponent implements OnInit {
  model: any = { };

  hideFilters: boolean = true;

  dateRange: any = 90;

  // Get today's date for the `from` and `to` max values
  today = moment().format('YYYY-MM-DD');
  dateFrom = moment().subtract(this.dateRange, 'days').format('YYYY-MM-DD');
  dateTo = this.today;

  rows = [];
  temp = [];
  selected = [];

  @ViewChild('table') table: DatatableComponent;

  constructor(
    private http: Http,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private angulartics2: Angulartics2,
    private loaderService: LoaderService
  ) {
    this.updateTable();
  }

  ngOnInit() {
    this.loaderService.setLoading();
  }

  toggleFiltersVisibility() {
    if (this.hideFilters == true) {
      this.hideFilters = false
    } else {
      this.hideFilters = true
    }
  }

  updateDateFrom(): any {
    this.dateFrom = moment().subtract(this.dateRange, 'days').format('YYYY-MM-DD');

    this.updateTable();

    this.angulartics2.eventTrack.next({ action: 'Date Filter Used', properties: { category: 'Sessions', label: this.dateRange + 'days' }});
  }

  // GET sessions from the API for the logged in user, and within the date range specified
  getSessions(cb) {
    let headers = new Headers();
    let params = new URLSearchParams();
    let where: any = {
      user: {
        className: "_User",
        objectId: this.apiService.Parse.User.current().id,
        __type: "Pointer"
      },
      startDate: {
        $gte: {
          iso: this.dateFrom,
          __type: "Date"
        },
        $lte: {
          iso: moment(this.dateTo).endOf('day'),
          __type: "Date"
        }
      }
    };

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    params.append('include', 'sessionSummary');
    params.append('order', '-startDate');
    params.append('where', JSON.stringify(where));

    let options = new RequestOptions({ headers: headers, params: params });

    return this.http.get(this.apiService.Parse.serverURL + '/classes/RideSession', options)
    .map(response => response.json()).subscribe(
      response => {
        cb(response.results);
        this.loaderService.setLoaded();
      },
      // error => console.log(error),
      () => {
        this.loaderService.setLoaded();
      }
    );
  }

  // Update the sessions table
  updateTable() {
    this.getSessions((data) => {
      // Cache the sessions temporarily for filtering purposes
      this.temp = [...data];
      // Push the sessions
      this.rows = data;
    });
  }

  // Search
  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // Filter our data
    const temp = this.temp.filter(function(d) {
      return d.title.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // Update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;

    this.angulartics2.eventTrack.next({ action: 'Title Filter Used', properties: { category: 'Sessions' }});
  }

  dateChanged() {
    if (this.dateFrom != moment().subtract(this.dateRange, 'days').format('YYYY-MM-DD')) {
      this.dateRange = 'custom';
    }

    this.updateTable();

    this.angulartics2.eventTrack.next({ action: 'Date Range Updated', properties: { category: 'Sessions' }});
  }

  // Navigate to selected session when the table row is clicked
  onActivate(event) {
    if (event.type == 'click') {
      let target = event.event.target.tagName.toLowerCase();

      if (target != 'label' && target != 'input') {
        this.router.navigate(['/session', event.row.objectId])
      }
    }
  }

  togglePrivacyState(event, objectId) {
    let headers = new Headers();
    let payload = {
      "isPrivate": event.target.checked,
    };

    // Set the HTTP headers
    headers.append('Content-Type', 'application/json');
    headers.append('X-Parse-Application-Id', environment.parse.appId);
    headers.append('X-Parse-javascript-Key', environment.parse.jsKey);
    if (this.apiService.Parse.User.current()) {
      headers.append('X-Parse-Session-Token', this.apiService.Parse.User.current().get('sessionToken'));
    }

    let options = new RequestOptions({ headers: headers });

    return this.http.put(this.apiService.Parse.serverURL + '/classes/RideSession/' + objectId, payload, options).subscribe(
      response => {
        this.angulartics2.eventTrack.next({ action: 'Session Privacy Updated', properties: { category: 'Sessions', label: event.target.checked ? 'Private' : 'Public' }});
      },
      // error => console.log(error),
      () => {}
    );
  }
}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/sessions/sessions.component.ts